import { render, staticRenderFns } from "./xtluckydrawlist.vue?vue&type=template&id=7cf08237&"
import script from "./xtluckydrawlist.vue?vue&type=script&lang=js&"
export * from "./xtluckydrawlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports